import { useRef } from "react";
import isEqual from "lodash/isEqual";
export var useDeepMemoize = function (value) {
  var prevValueRef = useRef(value);
  return isEqual(prevValueRef.current, value) || (prevValueRef.current = value), prevValueRef.current;
};